import React from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { TextInput } from '@vk-hr-tek/app-ui/form';
import { ValidationService } from '@vk-hr-tek/core/validation';

export const CommonSection = () => {
  const validator = useInject(ValidationService);

  return (
    <TextInput
      multiline
      required
      maxLength={120}
      name="common.name"
      debounceTimeout={200}
      label="Название опроса"
      placeholder="Добавьте название"
      helperText="Количество символов ограничено"
      validateArray={[validator.required('Обязательное поле')]}
    />
  );
};
